import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button, Form, Table, Spinner, Row, Col } from "react-bootstrap";
import Layout from "../components/Layout";
import appConstants from "../constants/appConstants";
import { FaArrowLeft } from "react-icons/fa";

const getAuthToken = () => localStorage.getItem("authToken");

const MarkEntryPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const termExamId = searchParams.get("term_exam_id");
  const subjectId = searchParams.get("subject_id");

  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [marks, setMarks] = useState({});
  const [examInfo, setExamInfo] = useState({});
  const [maxMark, setMaxMark] = useState("");


  const fetchStudents = async () => {
    setLoading(true);
    const token = getAuthToken();
    try {
      const res = await axios.get(
        `${appConstants.API_ROOT_URL}get-term-exam-students?term_exam_id=${termExamId}&subject_id=${subjectId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.status === "success") {
        const studentData = res.data.data;
        setStudents(studentData);
        const examInfo = res.data.exam_info;
        setExamInfo(examInfo);
        setMaxMark(examInfo.max_mark || "");
        const initialMarks = {};
        studentData.forEach((s) => {
          initialMarks[s.id] = s.marks_obtained || "";
        });
        setMarks(initialMarks);
      } else {
        alert(res.data.message || "Failed to load students");
      }
    } catch (err) {
      alert("Error fetching students");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleMarkChange = (studentId, value) => {
    setMarks((prev) => ({
      ...prev,
      [studentId]: value,
    }));
  };

  const saveMark = async (studentId, value) => {
    const token = getAuthToken();
    try {
      await axios.post(
        `${appConstants.API_ROOT_URL}save-exam-mark`,
        {
          term_exam_id: termExamId,
          subject_id: subjectId,
          student_id: studentId,
          marks_obtained: value,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (err) {
      console.error(`Error saving mark for student ${studentId}:`, err);
    }
  };

  const handleBlur = (studentId) => {
    saveMark(studentId, marks[studentId]);
  };

  const handleKeyDown = (e, studentId) => {
    if (e.key === "Enter") {
      e.preventDefault();
      saveMark(studentId, marks[studentId]);
    }
  };

  useEffect(() => {
    if (termExamId && subjectId) {
      fetchStudents();
    }
  }, [termExamId, subjectId]);

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <Layout>
      <div className="d-flex justify-content-between mb-3">
        <h4>Enter Term Exam Marks</h4>
        <Button variant="secondary" onClick={handleBackClick}>
          <FaArrowLeft className="me-2" />
          Back
        </Button>
      </div>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
        <div className="mb-3">
            <Form.Label><strong>Maximum Mark</strong></Form.Label>
            <div className="d-flex" style={{ gap: "10px", maxWidth: "300px" }}>
                <Form.Control
                type="number"
                value={maxMark}
                onChange={(e) => setMaxMark(e.target.value)}
                />
                <Button
                variant="success"
                onClick={async () => {
                    const token = getAuthToken();
                    try {

                    await axios.post(`${appConstants.API_ROOT_URL}save_exam_max_mark`, {
                        term_exam_id: termExamId,
                        subject_id: subjectId,
                        max_mark: maxMark,
                        }, {
                        headers: { Authorization: `Bearer ${token}` }
                        });



                    alert("Maximum mark saved.");
                    } catch (err) {
                    console.error("Error saving max mark:", err);
                    alert("Failed to save maximum mark.");
                    }
                }}
                >
                Save
                </Button>
            </div>
            </div>



        <div className="mb-3 p-3 border rounded bg-light">
        <Row className="align-items-center">
            <Col md="4">
            <strong>Exam:</strong> {examInfo.exam_name}
            </Col>
            <Col md="4">
            <strong>Class:</strong> {examInfo.class_name} {examInfo.division}
            </Col>
            <Col md="4">
            <strong>Subject:</strong> {examInfo.subject_name}
            </Col>
        </Row>
        </div>
        <Table bordered hover>
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Student Name</th>
              <th>Marks</th>
            </tr>
          </thead>
          <tbody>
            {students.map((s, idx) => (
              <tr key={s.id}>
                <td>{idx + 1}</td>
                <td>{s.student_name}</td>
                <td>
                  <Form.Control
                    type="text" // ✅ Changed to text
                    value={marks[s.id] || ""}
                    onChange={(e) => handleMarkChange(s.id, e.target.value)}
                    onBlur={() => handleBlur(s.id)}
                    onKeyDown={(e) => handleKeyDown(e, s.id)}
                    />

                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </>
      )}
    </Layout>
  );
};

export default MarkEntryPage;
